import AboutUsPage from "./aboutUsPage"

export default AboutUsPage;